module.exports = __webpack_public_path__ + "packs/media/images/Registration_Step_4-a75a877ac9a4827c085cd0b9ab39c257.jpg";